import { Injectable } from '@angular/core';
import { storageKeys, validatePromocodeApiTx } from 'src/app/app.constants';
import { BuyCertificatesService } from '../buy-certificates.service';
import { AppStateService } from '../init/app-state.service';
import { AnalyticsService } from '../core/analytics/analytics.service';
import { analyticsData } from 'src/app/analytics.constants';
import { ProfileService } from '../profile.service';
import { ActivateMembershipPayload, SignUpService } from '../sign-up.service';
import { SpouseMembershipService } from '../spouse-membership.service';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../common.service';
import { WalletService } from '../wallet.service';
import { HomeService } from '../home.service';
import { MembershipService } from '../membership.service';
import { StorageService } from '../core/storage/storage.service';
import { environment } from 'src/environments/environment';
import { AlertController, ModalController, NavController, Platform } from '@ionic/angular/standalone';
import { GiftMemberSuccessComponent } from 'src/app/modals/gift-member-success/gift-member-success.component';
import { AuthService } from '../auth.service';
import { SpouseActivationModalComponent } from 'src/app/modals/spouse-activation-modal/spouse-activation-modal.component';
import { RenewReactivateComponent } from 'src/app/modals/renew-reactivate/renew-reactivate.component';
import { AlertServiceService } from 'src/app/alert-service.service';
import { CustomizeComponent } from 'src/app/modals/customize/customize.component';
import { NavigationOptions } from '@ionic/angular/common/providers/nav-controller';
import { timer } from 'rxjs';

interface ParamData { data: any, gstDetails?: any, activateSpouse?: boolean, renewHeading?: string, activateMembershipPayload?: ActivateMembershipPayload }

@Injectable({
  providedIn: 'root'
})
export class PaymentDeeplinksService {

  constructor(
    private buyCertificateService: BuyCertificatesService,
    private appState: AppStateService,
    private analyticsService: AnalyticsService,
    private profileService: ProfileService,
    private signupService: SignUpService,
    private spouseMembershipService: SpouseMembershipService,
    private translate: TranslateService,
    private commonService: CommonService,
    private walletService: WalletService,
    private homeService: HomeService,
    private membershipService: MembershipService,
    private storageService: StorageService,
    private alertCtrl: AlertController,
    private modalController: ModalController,
    private auth: AuthService,
    private navController: NavController,
    private alertService: AlertServiceService
  ) { }

  public checkDeeplinks(params: URLSearchParams): void {
    console.log("Deeplink: ", params.toString())
    console.log("Type: ", params.get("type"))
    console.log("data: ", params.get("data"))
    console.log("atob data: ", atob(params.get("data")));
    const paramData: ParamData = JSON.parse(atob(params.get("data")))
    console.log("Param Data Before Transaction Details: ", paramData)
    paramData.data.transactionId = params.get("OrderMerchantReference")
    paramData.data.transactionCode = params.get("OrderTrackingId")
    paramData.data.paymentGateway = "Pesapal";
    console.log("Param Data After Transaction Details: ", paramData)
    switch (params.get("type")) {
      case validatePromocodeApiTx.certificatesBuy:
        console.log("Certificates Buy.")
        if (this.auth.isAuthenticated()) {
          this.buyCertificate(paramData)
        }
      break;
      case validatePromocodeApiTx.membershipBuy: 
        console.log("Membership Buy.")
        if (!paramData.data.preferredHotel) {
          console.log("Signup Case.")
          this.signupService.salutation = paramData.activateMembershipPayload?.name.salutation
          this.signupService.FirstName = paramData.activateMembershipPayload?.name.firstName
          this.signupService.LastName = paramData.activateMembershipPayload?.name.lastName
          this.signupService.mobile = paramData.activateMembershipPayload?.mobile
          this.signupService.countryCode = paramData.activateMembershipPayload?.countryCode
          this.signupService.email = paramData.activateMembershipPayload?.email
          this.signupService.countryId = paramData.activateMembershipPayload?.country
          this.signupService.cityName = paramData.activateMembershipPayload?.city
          this.signupService.promocodeCategory = paramData.activateMembershipPayload?.promocodeCategory
          this.signupService.memberActivationParams = { propertyID: paramData.activateMembershipPayload?.propertyID, customerSetID: paramData.activateMembershipPayload?.levels}
          this.buyMembership(paramData)
        } else {
          console.log("Logged In Case.")
          if (this.auth.isAuthenticated()) {
            this.getNewMembershipNumber(paramData)
          }
        }
      break;
      case validatePromocodeApiTx.membershipGift: 
        console.log("Membership Gift.")
        if (this.auth.isAuthenticated()) {
          this.giftMembership(paramData)
        }
      break;
      case validatePromocodeApiTx.membershipRenew: 
        console.log("Membership Renew.")
        if (this.auth.isAuthenticated()) {
          this.renewOrReactivateFunc(paramData)
        }
      break;
      case validatePromocodeApiTx.spouseMembershipBuy: 
        console.log("Spouse Membership Buy.")
        this.spouseMembershipService.spouseMemberPayload = paramData.data
        if (paramData.activateSpouse) {
          this.activateSpouseMembership(paramData)
        } else {
          this.buySpouseMembership(paramData)
        }
      break;
      case validatePromocodeApiTx.spouseMembershipRenew: 
        console.log("Spouse Membership Renew.")
        if (this.auth.isAuthenticated()) {
          this.renewSpouseMembership(paramData)
        }
      break;
      default: 
        console.log("Unknown flow.")
      break;
    }
  }
  
  private saveGstDetails(gstDetails: any) {
    let data = {
      gstDetails: [gstDetails]
    };
    this.profileService.addGstToProfile(data);
  }

  private buyCertificate(paramData: ParamData) {
    const appData = this.appState.getAppData();
    const memeberidEncrpit = this.appState.getEncryptedMemberId();
    this.buyCertificateService.buyCertificate(paramData.data, appData.membershipNumber.membershipNumber).then(
      (res) => {
        if (res) {
          if (Object.keys(paramData.data.gstNumber).length > 0) {
            this.saveGstDetails(paramData.gstDetails);
          }
          this.analyticsService.trackState(
            analyticsData.buypageSucussState,
            analyticsData.buypageSucussCdata,
            memeberidEncrpit
          );
          let cartArr = []
          const cartDetails = appData.cartDetails;
          const certificates = paramData.data.certificates
          cartDetails.forEach(ele => {
            if (certificates.findIndex(x => x.certificateID == ele.certificate.sfdcData.certificateCode) < 0) {
              cartArr.push(ele)
            }
          });
          this.appState.saveCartDetails(cartArr);
          this.modalController.create({
            component: GiftMemberSuccessComponent, 
            componentProps: {
              paymentSuccessDetails: {
                placeS: certificates.length > 1 ? 's' : '',
                areOrIs: certificates.length > 1 ? 'are' : 'is',
                transactionNumber: paramData.data.transactionId,
                currentBrand: appData?.appInitData?.brandConfig?.currentBrand || environment.currentBrand
              }
            }
          }).then(buyCertificate => {
            buyCertificate.present()
            buyCertificate.onDidDismiss().then((res) => {
              if (res.data === "navigateToHome") {
                this.navigateToHome()
              }
            }).catch(err => {
              console.log("onDidDismiss Error: ", err)
            })
          }).catch(err => {
            console.log("modalController.create Error: ", err)
          })
        }
      }
    ).catch(
      (err) => {
        this.analyticsService.trackState(
          analyticsData.buypageErrorState,
          analyticsData.buypageErrorCdata,
          memeberidEncrpit
        );
      }
    );
  }

  private buyMembership(paramData: ParamData) {
    this.signupService.activateMembership(paramData.gstDetails, paramData.data).then((res: any) => {
      if (res) {
        const createdMembership = res;
        this.spouseMembershipService.spouseCurrency = res.spouseMembership.currency;
        let memberidEncrpit = this.appState.getEncryptedMemberId();
        // this.callAnalytics(analyticsData.partnerPaymentSuccessPopUpFeeTrackState, analyticsData.partnerPaymentSuccessPopUpFee, memeberidEncrpit);
        let analyticData = analyticsData.welcomeToMembershipStateCdata;
        this.analyticsService.trackState(analyticData['cd.pagename'], analyticData, memberidEncrpit);
        this.modalController.create({
          component: CustomizeComponent,
          componentProps: {
            createdMembership: createdMembership,
            gsttext: paramData.gstDetails? true: false,
            transactionCode: paramData.data.transactionId
          } 
        }).then(customize => {
          customize.present()
          customize.onDidDismiss().then(() => {
            this.proceedToSpouse(createdMembership)
          }).catch(err => {
            console.log("onDidDismiss Error: ", err)
          })
        }).catch(err => {
          console.log("modalController.create Error: ", err)
        })
      } 
    });
  }

  getNewMembershipNumber(paramData: ParamData) {
    this.commonService.presentLoader(this.translate.instant('loader.globalMsgWait'));
    const appData = this.appState.getAppData()
    let memberType = null
    if (appData && appData.visitor) {
      memberType = appData.visitor.visitor;
    } else if (appData && appData.memberType) {
      memberType = appData.memberType.memberType;
    }
    this.walletService.buyAnotherMemebership(paramData.data).then((res) => {
      if (res) {
        if (memberType && (memberType.toLowerCase() === 'visitor')) {
            //console.log("response membership --->>",res.membershipNumber)            
            this.appState.removeData(storageKeys.visitor);
            this.appState.removeData(storageKeys.memberType);
            this.appState.saveMemberType({ memberType: 'member' });
            this.homeService.membershipNumber = res.membershipNumber;
            this.membershipService.membershipNumber = res.membershipNumber;
            const loginService = appData.loginService;
            loginService.membershipNumber = res.membershipNumber;
            this.appState.removeData(storageKeys.loginService).then(() => {
              this.appState.saveLoginServiceData(loginService);
            });
            this.appState.saveVisitor({
                visitor: ''
            });
            this.appState.removeData(storageKeys.aemCachedData).then(
                () => {
                    this.appState.saveAemData(this.homeService.COMPLETE_AEM_DATA);
                }
            );
            this.appState.removeData(storageKeys.membershipNumber).then(() => {
                this.storageService.set(storageKeys.membershipNumber, JSON.stringify({ membershipNumber: res.membershipNumber }), storageKeys.authenticated).then(respose => {
                      AppStateService.appData.membershipNumber = { membershipNumber: res.membershipNumber }
                      localStorage.setItem(environment?.headers?.program_id + ":" + storageKeys.membershipNumber, JSON.stringify({ membershipNumber: res.membershipNumber }));
                      // console.log("membership number --->>", AppStateService.appData.membershipNumber)
                    this.successHandle(paramData)
                }).catch(err => {
                    //console.log('saveMembershipNumber_Err =>', err);
                })
            });
        } else {
            this.successHandle(paramData)
        }
        this.commonService.isMembershipPurchased.next(true);
      }
      this.commonService.dismissLoader();
    }).finally(
        () => {
            this.commonService.dismissLoader();
        }
    );
  }


  private successHandle(paramData: ParamData) {
    const appData = this.appState.getAppData();
    console.log("appdata membership --->>",appData.membershipNumber)
    let transaction = null
    if (paramData.data.transactionId) {
        transaction = { transactionNumber: paramData.data.transactionId };
    }
    this.modalController.create({
      component: GiftMemberSuccessComponent, 
      componentProps: {
        transaction: { transactionNumber: paramData.data.transactionId }
      }
    })
    this.modalController.create({
      component: GiftMemberSuccessComponent, 
      componentProps: {
        transaction: { transactionNumber: paramData.data.transactionId }
      }
    }).then(buyMembership => {
      buyMembership.present()
      buyMembership.onDidDismiss().then((res) => {
        if (res.data === "navigateToWallet") {
          this.navigateToWallet(paramData)
        }
      }).catch(err => {
        console.log("onDidDismiss Error: ", err)
      })
    }).catch(err => {
      console.log("modalController.create Error: ", err)
    })
    let memeberidEncrpit = this.appState.getEncryptedMemberId();
    this.analyticsService.trackState(analyticsData.buyMoreMembershipSuccessState, analyticsData.buyMoreMembershipSuccessCdata, memeberidEncrpit);
    if (paramData.gstDetails) {
        this.profileService.addGstToProfile({ gstDetails: [paramData.gstDetails] })
    }
    console.log("newMembershipRequestData: ", paramData.data)
  }

   private giftMembership(paramData: ParamData) {
    const appData = this.appState.getAppData()
    //console.log("value is ", data);
    this.homeService.giftPayMent(paramData.data, appData.membershipNumber.membershipNumber).then((res: any) => { //refactored code nob-blocked task
      //console.log('Gift Payment', JSON.stringify(res))
      if (res) {
        if (res['statusCode'] == '200') {
          if (paramData.gstDetails) {
            const data = {
              gstDetails: [paramData.gstDetails]
            }
            this.profileService.addGstToProfile(data)
          }
          this.onClickProceedBtn(paramData.data)
        } else {
          this.handleAPIError(res);
        }
      } 
    }, err => {
      this.homeService.handleAPIError(err);
      //console.log("Error gift", err);
    })
  }

  // Modal Functionality
  private async onClickProceedBtn(data: any) {
    const giftee = data.giftee[0]
    console.log("Giftee Details: ", giftee)
    const modal = await this.modalController.create({
      component: GiftMemberSuccessComponent,
      componentProps: {
        giftedMemberDetails: {
          giftedMemberFirstName: giftee?.name?.firstName,
          giftedMemberLastName: giftee?.name?.secondName,
          transactionNumber: data.transactionId
        }
      },
      id: "GiftMemberSuccessComponent"
    });

    modal.present();


    let memeberidEncrpit = this.appState.getEncryptedMemberId()
    this.analyticsService.trackState(analyticsData.giftMembershipPaymentConfirmationState, analyticsData.giftMembershipPaymentConfirmationCdata, memeberidEncrpit);
    // let modal = document.getElementById("paymentModal");
    // modal.style.display = "flex";
  }

  //subscribe and unsubscribe
  private renewOrReactivateFunc(paramData: ParamData) {
    this.commonService.presentLoader(this.translate.instant('loader.globalMsgWait'));
    this.homeService.renewHeading = paramData.renewHeading
    this.homeService.membershipRelatedApi(this.homeService.renewHeading, paramData.data).then(res => { //refactored code nob-blocked task
      this.spouseMembershipService.spouseRenewPrice = res.spouseRenewalPrice;
      this.commonService.dismissLoader();
      if (res) {
        let brandName: any;
        brandName = {
            brandName: this.translate.instant('configJson.brandsName'),
          };
        if (paramData.data.transactionCode) {
          brandName.transactionNumber = paramData.data.transactionId;
        }
        if (this.homeService.renewHeading == storageKeys.renew_Membership) {
        const translationKey = paramData.data.transactionCode ? 'reactivate_Membership.renew_Payment' : 'reactivate_Membership.renew_Payment_without_transaction';
        const res: string = this.translate.instant(translationKey, brandName);

        this.modalController
          .create({
            component: RenewReactivateComponent,
            componentProps: {
              paymentDescription: res,
            },
          })
          .then((renewModal) => {
            renewModal.present();
            renewModal
              .onDidDismiss()
              .then(() => {
                this.closeRenewReactivateModal();
              })
              .catch((err) => {
                console.log("onDidDismiss Error: ", err);
              });
          })
          .catch((err) => {
            console.log("modalController.create Error: ", err);
          });
        } else {
          const translationKey = paramData.data.transactionCode
            ? "reactivate_Membership.reactivate_Payment"
            : "reactivate_Membership.reactivate_Payment_without_transaction";

          const res: string = this.translate.instant(translationKey, brandName);

          this.modalController
            .create({
              component: RenewReactivateComponent,
              componentProps: {
                paymentDescription: res,
              },
            })
            .then((renewModal) => {
              renewModal.present();
              renewModal
                .onDidDismiss()
                .then(() => {
                  this.closeRenewReactivateModal();
                })
                .catch((err) => {
                  console.log("onDidDismiss Error: ", err);
                });
            })
            .catch((err) => {
              console.log("modalController.create Error: ", err);
            });
        }
      }
      if (paramData.gstDetails) {
        this.saveGstDetails(paramData.gstDetails)
      }
    }, err => {
      this.commonService.dismissLoader();
      this.homeService.handleAPIError(err);
    })
  }

  private activateSpouseMembership(paramData: ParamData) {
    const appData = this.appState.getAppData();
    let flow: any;
    if (appData && appData.userType) {
      flow = appData.userType.userType;
    }
    this.spouseMembershipService.membershipNumber = appData.membershipNumber.membershipNumber;
    this.spouseMembershipService.enableSpouse(flow).then(
      async (spouseRes) => {
        if (spouseRes) {
          this.spouseHandleSuccess(paramData.data.transactionCode);
        }
      }
    ).finally(
      () => {
        // this.commonServ.dismissLoader();
      }
    );
  }

  private buySpouseMembership(paramData: ParamData) {
    console.log("buySpouseMembership", paramData.data.transactionCode)
    const appData = this.appState.getAppData();
    let flow: any;
    if (appData && appData.userType) {
      flow = appData.userType.userType;
    }
    this.spouseMembershipService.membershipNumber = appData.membershipNumber.membershipNumber;
    this.spouseMembershipService.createSpouseMembership(flow).then(
      async (spouseRes) => {
        if (spouseRes) {
            this.spouseHandleSuccess(paramData.data.transactionCode);
        }
      }
    ).finally(
      () => {
        // this.commonServ.dismissLoader();
      }
    );
  }

  private async spouseHandleSuccess(paramData: ParamData){
    this.openSpouseModal(paramData, false)
    this.commonService.isSpouseJustAdded = true;
    if (paramData.gstDetails) {
      this.saveGstDetails(paramData.gstDetails)
    }
    let memeberidEncrpit = this.appState.getEncryptedMemberId()
    this.analyticsService.trackState(analyticsData.spouseEventsStateSuccessPopUp, analyticsData.spouseEventsCdataSuccessPopUp, memeberidEncrpit);
  }

  private renewSpouseMembership(paramData: ParamData) {
    const appData = this.appState.getAppData();
    this.spouseMembershipService.membershipNumber = appData.membershipNumber.membershipNumber;
    this.spouseMembershipService.spouseMembership = appData.profileDetails?.spouseCardDetails?.spousemembershipNumber;
    this.spouseMembershipService.renewSpouseMembership(paramData.data.paymentGateway, paramData.data.transactionId, paramData.data.transactionCode).then(
      (res) => {
        if (res) {
          this.openSpouseModal(paramData, true)
          if (paramData.gstDetails) {
            this.saveGstDetails(paramData.gstDetails)
          }

          let memeberidEncrpit = this.appState.getEncryptedMemberId()
          this.analyticsService.trackState(analyticsData.spouseEventsStateSuccessPopUp, analyticsData.spouseEventsCdataSuccessPopUp, memeberidEncrpit);

        }
      }
    )
  }

  private async openSpouseModal(paramData: ParamData, spouseRenew: boolean) {
    const spouseModal = await this.modalController.create({
      component: SpouseActivationModalComponent,
      componentProps: { transactionNumber: paramData.data.transactionId, spouseRenew: spouseRenew },
      id: "SpouseActivationModalComponent"
    });
    spouseModal.present();
}

  private async handleAPIError(error: any) {
    const errorAlert = await this.alertCtrl.create({
      backdropDismiss: false,
      message: error.statusMessage || 'Something Went Wrong',
      buttons: ["OK"],
      mode: "ios",
      cssClass: "alertCustomCss"
    });
    await errorAlert.present();
  }

  private closeRenewReactivateModal() {
    this.commonService.afterSpouseAddOrSkipPath = 'tabs';
    this.commonService.presentLoader(this.translate.instant('loader.fetchData'));
    this.homeService.getHomeCRMDetails().then(
      (res) => {
        if (res) {
          this.membershipService.getMembershipCRMDetails().then( //refactored code nob-blocked task
            (membershipResponse) => {
              this.profileService.getProfileDetails().then(res => {
                this.commonService.dismissLoader();
                if (res.profileDetails.spouseCardDetails.spouseCardExist) {
                  this.navController.navigateRoot('spouse-membership');
                } else {
                  if (res.profileDetails.spouseCardDetails.spouseCreateFlag) {
                    this.navController.navigateRoot('spouse-membership');
                  } else {
                    this.navController.navigateRoot('/tabs/subscription');
                  }
                }
              },
                (memberErr) => {
                  this.commonService.dismissLoader();
                  this.navController.navigateRoot('tabs')
                })
            },
            (memberErr) => {
              this.commonService.dismissLoader();
              this.navController.navigateRoot('tabs')
            }
          );
        } else {
          this.commonService.dismissLoader();
          this.navController.navigateRoot('tabs')
        }
      },
      (err) => {
        this.navController.navigateRoot('tabs')
      }
    );
  }

  private proceedToSpouse(createdMembership: any) {
    let memberidEncrpit = this.appState.getEncryptedMemberId();
    this.analyticsService.trackAction(this.translate.instant("register_user.proceed"), analyticsData.partnerPaymentSuccessPopUpFeeclick, analyticsData.partnerPaymentSuccessPopUpFeeCtaName, memberidEncrpit);
    let analyticData = analyticsData.welcomeToMembershipActionProceed;
    this.analyticsService.trackAction(analyticData['cd.ctaname'], analyticData, null, memberidEncrpit);

    this.appState.saveMemberType({ memberType: 'member' });
    this.signupService.promocodeApplied = false;
    this.signupService.promocodeApiResponse = undefined;
    this.signupService.promoCode = undefined;
    if (createdMembership.spouseCreateFlag) { // Skip Spouse TMA-4295
        this.navController.navigateRoot('spouse-membership');
    } else {
        this.unlockBenefit();
    }
  }

  private async unlockBenefit() {
    if (this.commonService.internetStatus) {
       this.commonService.presentLoader(this.translate.instant('loader.unlockBenefit'));
        var req = {
            "isProgBenTnCChecked": 'true',
            "isMembershipActivated": "true",
            "isMobileVerified": "true",
            "isEmailVerified": "true",
            "favHotel": ""
        }
        this.signupService.postUnlockBenefits(req, this.signupService.memberShipNumber).then(async (res) => {
            //console.log("unlock benefits success", res);
            this.commonService.dismissLoader();
            if (res) {
                console.log("COMPLETE_AEM_DATA --->> ", this.homeService.COMPLETE_AEM_DATA);
                // if(this.homeService.COMPLETE_AEM_DATA && this.homeService.COMPLETE_AEM_DATA.onboarding.activationPopup && this.homeService.COMPLETE_AEM_DATA.onboarding.activationPopup.description1){
                //     const welcomeModal = await this.modalController.create({
                //       component: WelcomeModalComponent,
                //       id: "WelcomeModalComponent"
                //     });
                //     welcomeModal.present();
                // } else {
                    this.signupService.memberType = 'member';
                    this.membershipSuccessHandle();
                // }
            }
        }).catch((err) => {
            //console.log("unlock benefits err", JSON.stringify(err.error.errorMessage));
            this.commonService.dismissLoader();
            this.alertService.errorAlertController(err);
        })
    } else {
      //subscribe and usubscribe
      this.commonService.presentToast(this.translate.instant('toastMsg.checkInternet'));
    }
  }

  private membershipSuccessHandle() {
    let memberidEncrpit = this.appState.getEncryptedMemberId()
    let analyticData = analyticsData.welcomeToActionClose;
    if (AppStateService.appData.visitor) {
        if (AppStateService.appData.visitor.visitor == 'visitor')
            analyticData['cd.section2'] = "Guest Flow";
    }
    console.log("Analytic data::>", analyticData);
    this.analyticsService.trackState(analyticData['cd.pagename'], analyticData, memberidEncrpit);
    this.afterMembershipActivation();
  }

 async afterMembershipActivation() {
    // this.translate.get('loader.fetchData').subscribe((res: string) => {
    //     this.commonService.presentLoader(res)
    // });
    this.homeService.getHomeCRMDetails().then(res => {
        if (res) {
            //console.log('Home Api Res--->>>', res);
            this.homeService.setDefaultMembershipNumber();
            const ionicStorageData: any = {}
            ionicStorageData.aemUrl = this.homeService.aemUrl;
            ionicStorageData['isLoggedIn'] = "true";
            ionicStorageData.currentUrlPath = 'tabs';
            this.appState.saveSignupServiceData(ionicStorageData);
            this.homeService.flow = 'signup';
            localStorage.setItem(environment?.headers?.program_id + ":" + "isLoggedIn", "true");
            this.auth.authenticationState.next(true);
            let navigationOptions: NavigationOptions = {
                state: {
                    isUserFirstTime: true
                }
            }
            this.navController.navigateRoot('/tabs', navigationOptions);
            this.commonService.isLoggedIn = true;
            this.commonService.dismissLoader();
            this.membershipService.getMembershipCRMDetails().then(res => { //refactored code nob-blocked task
                //console.log('MembershipDetails_Succ ==> ', res);
            }, err => {
                //console.log('MembershipDetails_Err ==> ', err);
                this.commonService.dismissLoader();
                this.homeService.handleAPIError(err)
            })
        } else {
            this.commonService.dismissLoader();
        }
    }, err => {
        this.commonService.dismissLoader();
        this.homeService.handleAPIError(err)
    });
  }

  private navigateToWallet(paramData: ParamData) {
    let memberType = null
    const appData = this.appState.getAppData()
    if (appData && appData.visitor) {
        memberType = appData.visitor.visitor;
    } else if (appData && appData.memberType) {
        memberType = appData.memberType.memberType;
    }
    if (memberType.toLowerCase() === 'visitor') {
        this.updateDataForNewMemberInVisitorCase(paramData);
    } else {
      //refactoring the code
      timer(100).subscribe(() => {
          this.commonService.selectedItem = 'wallet'
      });
        this.navController.navigateForward('tabs/profile');
    }

    let memeberidEncrpit = this.appState.getEncryptedMemberId();
    this.analyticsService.trackAction('Proceed', analyticsData.buyMoreMembershipSuccessAction, analyticsData.buyMoreMembershipSuccessClick, memeberidEncrpit);
  }

  //subscribe and unsubscribe 
  private updateDataForNewMemberInVisitorCase(paramData: ParamData) {
    this.commonService.presentLoader(this.translate.instant('loader.fetchData'));
    const customerSetID = paramData.data.levels
    console.log("customerSetID--->", customerSetID)
    this.appState.saveMembershipTypeID({ 'membershipTypeID': customerSetID });
    this.homeService.setDefaultMembershipNumber();
    this.homeService.getHomeCRMDetails().then(
        (res) => {
            if (res) {
              this.commonService.dismissLoader();
              this.commonService.presentLoader(this.translate.instant('loader.fetchData'))
              this.membershipService.getMembershipCRMDetailsWithoutLoader().then( //refactored code nob-blocked task
                  (membershipRes) => {
                    if (membershipRes) {
                        this.commonService.dismissLoader();
                        this.commonService.presentLoader(this.translate.instant('loader.fetchData'))
                        this.profileService.getProfileDetails().then(
                            (profileRes) => {
                                if (profileRes) {
                                    this.commonService.dismissLoader();
                                    // this.navCtrl.setDirection("root");
                                    this.membershipService.membershipChange.next(true);
                                    this.navController.navigateRoot('/');
                                } else {
                                    this.commonService.dismissLoader();
                                }
                            }
                        );
                    } else {
                      this.commonService.dismissLoader();
                    }
                  }
              );
            } else {
                this.commonService.dismissLoader();
            }
        }
    );
  }

  private navigateToHome() {
      this.homeService.getHomeCRMDetails().then(res => {
        // //console.log('Home_APICalled');
      }); 
      this.commonService.presentLoader(this.translate.instant('loader.fetchData'));
     
      this.membershipService.getMembershipCRMDetailsWithoutLoader().then(res => { //refactored code nob-blocked task
        this.commonService.dismissLoader()
        //console.log(" All paid -->>", flag)
        this.navController.navigateForward("/tabs/subscription").then(
          () => {
            this.appState.removeData(storageKeys.cartDetails);
          }
        );
      }, err => {
        this.commonService.dismissLoader();
      });
  }
}
